import { render, staticRenderFns } from "./RiskGrade.vue?vue&type=template&id=a0504888&scoped=true"
import script from "./RiskGrade.vue?vue&type=script&lang=js"
export * from "./RiskGrade.vue?vue&type=script&lang=js"
import style0 from "./RiskGrade.vue?vue&type=style&index=0&id=a0504888&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0504888",
  null
  
)

export default component.exports